<template>
  <div>
    <v-row dense>
      <v-col cols="12" sm="6">
        <div>
          <template>
            <div>
              <template>
                <v-row dense>
                  <v-col cols="12" :sm="isBulk ? '6' : '12'">
                    <v-text-field
                      :label="barcodeStartLabel"
                      v-model="barcodeField"
                      id="barcodeField"
                      @input="emitBagBarcodeChange"
                      v-mask="isEditable ? bagBarcodeMask : null"
                      :rules="bagBarcodeRule"
                      :error-messages="
                        showBarcodeError ? barcodeErrorMessage : ''
                      "
                      :disabled="
                        active_sample.id !== null ||
                          (active_sample.number_of_samples > 0 && isBulk)
                      "
                    >
                      <template #append>
                        <!-- Make the icon clickable -->
                        <img
                          src="@/assets/Barcode.png"
                          alt="icon"
                          style="cursor: pointer;"
                          @click="openQrScanner(true)"
                        />
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" :sm="isBulk ? '6' : '12'" v-if="isBulk">
                    <v-text-field
                      :label="barcodeEndLabel"
                      v-model="barcode_end"
                      id="barcode_end"
                      v-mask="isEditable ? bagBarcodeMask : null"
                      :rules="bagBarcodeRule"
                      :error-messages="
                        showBarcodeError ? barcodeErrorMessage : ''
                      "
                      :disabled="
                        active_sample.id !== null ||
                          (active_sample.number_of_samples > 0 && isBulk)
                      "
                    >
                      <template #append>
                        <img
                          src="@/assets/Barcode.png"
                          alt="icon"
                          style="cursor: pointer;"
                          @click="openQrScanner(false)"
                          v-if="!active_sample.id"
                        />
                      </template>
                    </v-text-field>
                  </v-col>

                  <!-- QR Scanner Dialog -->
                  <v-dialog v-model="showQrScanner" max-width="400px">
                    <v-card>
                      <v-card-title>Scan QR Code</v-card-title>
                      <v-card-text>
                        <!-- <qrcode-stream
                          v-if="scannerActive"
                          @decode="onQrDecode"
                          @init="onQrInit"
                          :formats="['qr_code', 'code_128', 'ean_13']"
                        ></qrcode-stream> -->
                        <StreamBarcodeReader
                          @decode="onDecodeBarCode"
                          @init="onQrInit"
                          ref="scanner"
                          v-if="scannerActive"
                        ></StreamBarcodeReader>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          text
                          color="red"
                          id="closeScanner"
                          @click="closeScanner"
                          >Cancel</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                  <!-- Number of Samples Dialog -->
                  <v-dialog v-model="isBulkBarCodeDialog" max-width="400px">
                    <v-card style="padding-top: 1rem; text-align: center;">
                      <img
                        src="@/assets/number_of_samples.svg"
                        alt="number of samples icon"
                        style="display: flex; margin: auto;"
                      />
                      <v-card-title style="justify-content: center;">
                        Generate Samples
                      </v-card-title>
                      <v-card-text>
                        Please enter the number of samples
                      </v-card-text>
                      <v-col cols="12">
                        <v-text-field
                          label="Enter Number"
                          v-model="numberOfSamplesValue"
                          v-mask="numberOfSampleseMask"
                          id="numberOfSamplesValue"
                        >
                        </v-text-field>
                      </v-col>
                      <v-card-actions
                        style="justify-content: center; gap: 2rem;
                        text-transform: none !important;"
                      >
                        <v-btn
                          color="primary"
                          @click="saveNumberOfSamplesValue"
                          id="saveNumberOfSamplesValue"
                          >Generate</v-btn
                        >
                        <v-btn
                          text
                          class="back-btn"
                          @click="closeNumberOfSamplesDialog"
                          id="closeNumberOfSamplesDialog"
                          >Back</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-row>
              </template>
            </div>
          </template>
        </div>
      </v-col>
      <v-col cols="12" sm="6">
        <div
          style="display: flex; align-items: center; margin-top: 1rem; gap: 1rem;"
        >
          <v-btn
            class="barcode-btn"
            @click="handleClickGenerateBagBarCode"
            id="generateBagBarCode"
            :disabled="active_sample.id || (isBulk && number_of_samples > 0)"
          >
            Generate
            <img
              src="@/assets/fi_17653539.png"
              alt="upload icon"
              style="width: 20px; height: 20px; margin-left: 8px;"
            />
          </v-btn>
          <v-btn
            class="barcode-btn"
            id="barcodeBtn"
            @click="switchMode"
            v-if="!isEdit"
          >
            {{ isBulk ? "Single" : "Bulk" }} {{ " Submission" }}
            <img
              src="@/assets/submission-icon.svg"
              alt="upload icon"
              style="width: 20px; height: 20px; margin-left: 8px;"
            />
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" sm="2">
        <v-dialog v-model="farmDialog" persistent>
          <FarmAddDialog v-bind:dialog.sync="farmDialog"></FarmAddDialog>
        </v-dialog>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="6">
        <div>
          <template>
            <div>
              <template>
                <v-row dense>
                  <v-col>
                    <v-autocomplete
                      :items="labs"
                      :filter="customFilter"
                      :rules="rules.required"
                      label="Select a Lab *"
                      :no-data-text="labsMessage"
                      item-text="title"
                      item-value="id"
                      :value="value"
                      @input="emitChange"
                      :disabled="
                        active_sample.id != null && active_sample.lab_id != null
                      "
                      @change="saveToLocalStorage('lab_id')"
                      v-model="lab_id"
                      id="lab_id"
                    >
                      <template v-slot:label>
                        <h4>
                          Select a Lab
                          <span style="color: red;">
                            *
                          </span>
                        </h4>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </template>
            </div>
          </template>
        </div>
      </v-col>
      <v-col cols="12" sm="6">
        <v-autocomplete
          :items="farms"
          :rules="rules.required"
          label="Farm Name *"
          no-data-text="No farms to select from"
          item-text="title"
          item-value="id"
          v-model="farm_id"
          id="farm_id"
          clearable
          @change="saveToLocalStorage('farm_id')"
        >
          <template v-slot:label>
            <h4>
              Farm Name
              <span style="color: red;">
                *
              </span>
            </h4>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" sm="2">
        <v-dialog v-model="farmDialog" persistent>
          <FarmAddDialog v-bind:dialog.sync="farmDialog"></FarmAddDialog>
        </v-dialog>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="6">
        <v-autocomplete
          :items="validSources"
          label="Feed Sources"
          no-data-text="No feed sources to select from"
          item-text="title"
          item-value="id"
          v-model="farms_source_id"
          id="farms_source_id"
          clearable
          @change="saveToLocalStorage('farms_source_id')"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6">
        <v-autocomplete
          :items="feed_types"
          :rules="rules.required"
          label="Feed Type *"
          no-data-text="No feed types to select from"
          item-text="title"
          item-value="id"
          v-model="feed_type_id"
          id="feed_type_id"
          :disabled="!!quick_feed_type"
          @change="handleFeedTypeChange"
        >
          <template v-slot:label>
            <h4>
              Feed Type
              <span style="color: red;">
                *
              </span>
            </h4>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="12">
        <v-textarea
          v-model="description"
          id="description"
          label="Description"
          :rules="rules.description"
        ></v-textarea>
      </v-col>
    </v-row>
    <template>
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header id="additionalInfo">
            Additional Info
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row dense>
              <v-col>
                <v-autocomplete
                  :items="cuttingOptions"
                  :filter="customFilter"
                  label="Cutting"
                  no-data-text="No matches were found"
                  :value="value"
                  @input="emitChange"
                  v-model="cutting"
                  id="cutting"
                >
                  <template v-slot:label> </template>
                </v-autocomplete>
              </v-col>
              <v-col>
                <v-autocomplete
                  :items="sampleConditionOptions"
                  :filter="customFilter"
                  label="Sample Condition"
                  no-data-text="No matches were found"
                  :value="value"
                  @input="emitChange"
                  v-model="sample_condition"
                  id="sample_condition"
                  item-text="text"
                  item-value="value"
                >
                  <template v-slot:label> </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <DatePickerInput
                  :default-value="date_collected"
                  :date-picker-config="dateCollected"
                  @updateDateField="
                    (field, val) => {
                      date_collected = val;
                    }
                  "
                  :clearable="true"
                  id="date_collected"
                ></DatePickerInput>
              </v-col>
              <v-col>
                <v-autocomplete
                  :items="preGroundOptions"
                  :filter="customFilter"
                  label="PreGround"
                  no-data-text="No matches were found"
                  item-text="text"
                  item-value="value"
                  :value="value"
                  @input="emitChange"
                  v-model="is_preground"
                  id="is_preground"
                >
                  <template v-slot:label> </template>
                </v-autocomplete>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col>
                <v-autocomplete
                  :items="cropYears"
                  label="Crop Year"
                  no-data-text="No matches were found"
                  @input="emitChange"
                  v-model="crop_year"
                  id="crop_year"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <!-- <v-row>
              <v-col>
                <v-autocomplete
                  :items="shownCopyTos"
                  label="Report Recipients"
                  no-data-text="No report recipients were found"
                  item-text="email"
                  item-value="id"
                  @input="emitChange"
                  v-model="copy_to"
                  multiple
                  chips
                  deletable-chips
                  return-object
                  id="copyTo"
                >
                  <template v-slot:label> </template>
                </v-autocomplete>
              </v-col>
            </v-row> -->
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>
    <v-row v-if="is_linked" dense>
      <v-col>
        <v-alert dense type="info">
          Linked samples include samples logged for apparent nutrient
          digestibility testing, mixer evaluations, duplicate samples, etc.
        </v-alert>
      </v-col>
    </v-row>
    <v-row v-if="is_linked" dense>
      <LoadingBar v-if="loading === true" />
      <v-col>
        <LinkedSamples />
      </v-col>
    </v-row>
    <v-row v-if="selectedClient.is_grand_valley === true" dense>
      <div class="h6 py-2 font-weight-bold">Grand Valley</div>
    </v-row>
    <v-row v-if="selectedClient.is_grand_valley === true" dense>
      <v-col cols="4">
        <v-text-field
          v-model="gv_sales_rep_name"
          label="Sales Rep. Name"
        ></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="gv_sales_rep_number"
          label="Sales Rep. Number"
        ></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="gv_file_number"
          label="File Number"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row v-if="selectedClient.is_wallensteins === true" dense>
      <div class="h6 py-2 font-weight-bold">Wallensteins</div>
    </v-row>
    <v-row v-if="selectedClient.is_wallensteins === true" dense>
      <v-col cols="4">
        <v-text-field
          v-model="wallensteins_req_id"
          label="Requester ID"
        ></v-text-field>
      </v-col>
    </v-row>
    <feed-type-reminder-dialog v-model="feedTypeReminder" @ok="handleClickOk" />
  </div>
</template>
<script>
import rules from "@/utils/rules";
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import { mapFields } from "vuex-map-fields";
import LoadingBar from "@/components/loaders/LoadingBar";
import LinkedSamples from "@/components/samples/SampleWizardSteps/SampleStepComponents/LinkedSamples";
import { validId } from "@/utils";
import FarmAddDialog from "@/components/farms/FarmAddDialog";
import hasIn from "lodash.hasin";
import DatePickerInput from "@/components/formElements/DatePickerInput";
import Vue from "vue";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import dayjs from "dayjs";
import { StreamBarcodeReader } from "vue-barcode-reader";
import FeedTypeReminderDialog from "../../components/FeedTypeReminderDialog.vue";

const bagBarcodeMask = createNumberMask({
  prefix: "",
  suffix: "",
  allowDecimal: false,
  includeThousandsSeparator: false,
  integerLimit: 8,
  decimalLimit: 0,
  allowNegative: false,
  allowLeadingZeroes: false
});

const numberOfSampleseMask = createNumberMask({
  prefix: "",
  suffix: "",
  allowDecimal: false,
  includeThousandsSeparator: false,
  integerLimit: 3,
  decimalLimit: 0,
  allowNegative: false,
  allowLeadingZeroes: false
});

export default {
  name: "GeneralSampleInformation",
  props: {
    value: [String, Number],
    showBarcodeError: Boolean,
    clearable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    initialInfo: {
      type: String,
      default: ""
    },
    showCreateNew: {
      type: Boolean,
      default: false
    }
  },
  components: {
    FarmAddDialog,
    LoadingBar,
    LinkedSamples,
    DatePickerInput,
    StreamBarcodeReader,
    FeedTypeReminderDialog
  },
  data() {
    return {
      loading: false,
      feedTypeReminder: false,
      isEditable: false,
      isStartBarCodeScanned: false,
      isBulkBarCodeDialog: false,
      saveNumberOfSamples: false,
      numberOfSamplesValue: null,
      barcodeErrorMessage: "",
      mediaStream: null,
      cuttingOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      bagBarcodeMask,
      numberOfSampleseMask,
      showQrScanner: false,
      scannerActive: false,
      isEdit: window.location.pathname.includes("sample-edit"),
      sampleConditionOptions: [
        { text: "Wet", value: "wet" },
        { text: "Dry", value: "dry" }
      ],
      preGroundOptions: [
        { text: "Yes", value: true },
        { text: "No", value: false }
      ],
      dateCollected: {
        label: "Sampled Date",
        field: "date_collected",
        maxDate: dayjs().format("YYYY-MM-DD")
      },
      dateHarvested: {
        label: "Harvest Date",
        field: "date_harvested"
      },
      rules: {
        required: [rules.required],
        alphanumericRequired: [rules.required, rules.alphanumeric],
        description: [rules.maxLength(255)]
      },
      farmDialog: false,
      sourceDialog: false
    };
  },
  computed: {
    ...mapFields("sampleWizard", [
      "wizard.feed_class",
      "wizard.isBulk",
      "wizard.sampleIds",
      "wizard.quick_feed_type"
    ]),
    ...mapGetters("clients", ["selectedClient"]),
    ...mapFields("samples", [
      "active_sample.farm_id",
      "active_sample.farms_source_id",
      "active_sample.feed_type_id",
      "active_sample.shipment_id",
      "active_sample.description",
      "active_sample.is_preground",
      "active_sample.is_fresh",
      "active_sample.grind_size",
      "active_sample.dry_matter_method",
      "active_sample.grind_method",
      "active_sample.date_collected",
      "active_sample.date_harvested",
      "active_sample.cutting",
      "active_sample.sample_condition",
      "active_sample.is_linked",
      "active_sample.linked_samples",
      "active_sample.copy_to",
      "active_sample.copy_to_ids",
      "active_sample.is_sample_bag",
      "active_sample.sample_bag_barcode",
      "active_sample.gv_file_number",
      "active_sample.gv_sales_rep_name",
      "active_sample.gv_sales_rep_number",
      "active_sample.barcode_start",
      "active_sample.barcode_end",
      "active_sample.number_of_samples",
      "active_sample.crop_year",
      "active_sample.wallensteins_req_id"
    ]),
    ...mapFields("samples", {}),
    ...mapGetters("baseData", ["labs"]),
    filteredLabs() {
      return this.labs.filter(lab => lab.is_active === true);
    },
    cropYears() {
      const startYear = 2001;
      const currentYear = new Date().getFullYear();
      return Array.from(
        { length: currentYear - startYear + 1 },
        (_, i) => startYear + i
      );
    },
    ...mapState("sources", { farmSource: "detailItem" }),
    ...mapState("copyTo", { copyTos: "items" }),
    ...mapGetters("baseData", [
      "filterById",
      "getQuickFeedTypes",
      "feed_types",
      "feed_classes"
    ]),
    ...mapGetters("sources", { sources: "getActiveItems" }),
    ...mapGetters("farms", { farms: "getActiveItems" }),
    ...mapGetters("labs", { labs: "getItems" }),
    ...mapGetters("labs", { labsMessage: "getMessage" }),
    feed_class_id: {
      get() {
        // If there's a feed_class defined, use that
        if (validId(this.feed_class)) return this.feed_class;
        // Otherwise, check if a feed_type was selected and use its feed class
        if (this.feed_type_id) {
          const feed_type = this.feed_types.find(
            item => item.id === this.feed_type_id
          );
          if (feed_type) return feed_type.feed_class_id;
        }
        // Otherwise, we don't have a value to return
        return null;
      },
      set(newVal) {
        // When clearing the value, also clear the feed type. This is a filter field after all.
        if (newVal === null) this.feed_type_id = null;
        // Always update the local feed_class, since feed_class_id is computed on the entity
        this.feed_class = newVal;
      }
    },
    feedTypesByClass() {
      return !this.feed_class_id
        ? this.feed_types
        : this.feed_types.filter(
            item => item.feed_class_id === this.feed_class_id
          );
    },
    ...mapFields("samples", ["active_sample.lab_id"]),
    ...mapGetters("clients", ["selectedClient", "hasMultipleClients"]),
    ...mapState("clients", { clients: "items" }),
    ...mapState("samples", ["active_sample"]),
    routeSampleId() {
      return hasIn(this.$route, "params.sampleId")
        ? this.$route.params.sampleId
        : null;
    },
    bagBarcodeRule() {
      if (!this.isBulk) {
        return [
          ...this.rules.required,
          () => this.barcodeErrorMessage || true,
          this.validateBarcodeRange
        ];
      } else {
        return [
          () => this.barcodeErrorMessage || true,
          this.validateBarcodeRange
        ];
      }
    },
    barcodeField: {
      get() {
        return this.isBulk ? this.barcode_start : this.sample_bag_barcode;
      },
      set(value) {
        if (this.isBulk) {
          this.barcode_start = value;
        } else {
          this.sample_bag_barcode = value;
        }
      }
    },
    shownCopyTos() {
      return this.copyTos.filter(
        item =>
          item.is_active &&
          item.o_user_id &&
          item?._matchingData?.ClientsCopyTo?.client_id ==
            this.selectedClient?.id
      );
    },
    disableBarcodeGenerationButton() {
      return (
        this.active_sample.id ||
        (this.isBulk && this.active_sample.number_of_samples > 0) ||
        (this.isBulk &&
          (this.barcode_start?.length > 0 || this.barcode_end?.length > 0))
      );
    },
    barcodeStartLabel() {
      if (this.isBulk) {
        if (
          this.active_sample.id != null ||
          this.active_sample.number_of_samples > 0
        )
          return "Auto-generated";
        else {
          return "Sample Bag Barcode Start";
        }
      }
      return "Sample Bag Barcode";
    },
    barcodeEndLabel() {
      if (
        this.active_sample.id != null ||
        this.active_sample.number_of_samples > 0
      )
        return "Auto-generated";
      else {
        return "Sample Bag Barcode End";
      }
    },
    validSources() {
      return this.sources.filter(s => s.feed_type_id);
    }
  },
  methods: {
    ...mapActions("sources", ["getFarmSource", "getFarmSources"]),
    ...mapActions("samples", ["getSamples"]),
    ...mapActions("farms", ["getActiveFarms"]),
    ...mapActions("labs", ["getClientLabs"]),
    onDecodeBarCode(result) {
      this.onQrDecode(result);
    },
    ...mapMutations("samples", ["setActiveSampleCopyTo"]),
    customFilter(item, queryText) {
      const title = item.title.toLowerCase();
      const searchText = queryText.toLowerCase();

      return title.indexOf(searchText) > -1;
    },
    emitChange(value) {
      this.isEditable = true;
      this.$emit("input", value);
    },
    emitBagBarcodeChange() {
      if (this.barcodeErrorMessage) {
        this.showBarcodeError = false;
        this.barcodeErrorMessage = "";
      }
      this.isEditable = true;
      this.$emit("change", this.sample_bag_barcode);
    },
    handleFeedTypeChange() {
      if (this.farms_source_id) {
        this.saveToLocalStorage("feed_type_id");
        this.feedTypeReminder = true;
      }
    },
    handleClickOk() {
      this.feedTypeReminder = false;
      this.farms_source_id = null;
    },
    populateFeedFields(val) {
      if (val) {
        this.feed_class_id = val.feed_class_id;
        this.feed_type_id = val.id;
      } else {
        this.feed_class_id = null;
        this.feed_type_id = null;
      }
    },
    updateDateField(field, value) {
      this[field] = value;
    },
    search(val) {
      return val && val !== this.value && this.loading !== true;
    },
    isLinkedPopulate() {
      if (this.is_linked) {
        this.loading = true;
        // @TODO: this needs to be updated to bring samples into the component that are needed, because samples will be paginated
        this.getSamples().finally(() => {
          this.loading = false;
        });
      } else {
        this.linked_samples = [];
      }
    },
    sampleBagBarcodeFocus() {
      this.$nextTick(() => {
        if (this.$refs.bagbarcode) {
          this.$refs.bagbarcode.focus();
        }
      });
    },
    saveToLocalStorage(key) {
      localStorage.setItem(key, JSON.stringify(this[key]));
    },
    validateBarcodeRange(value) {
      if (!value) return true;

      // If number type (manual input?), just save and allow
      if (typeof value === "number") {
        this.saveToLocalStorage("sample_bag_barcode");
        return true;
      }

      // If string and we have saved value in localStorage, sync it
      if (
        typeof value === "string" &&
        localStorage.getItem("sample_bag_barcode")
      ) {
        let savedBarCode = localStorage.getItem("sample_bag_barcode");
        if (Number(value) === Number(savedBarCode)) {
          this.sample_bag_barcode = Number(value);
          return true;
        }
      }

      // Basic barcode rule
      const baseValidation =
        (value.length === 7 &&
          Number(value.charAt(0)) >= 2 &&
          typeof value === "string") ||
        "Barcode must be starting with 2M and less than 10M";

      // If base validation failed → return immediately
      if (baseValidation !== true) return baseValidation;

      // Additional check for bulk mode
      if (this.isBulk) {
        if (this.barcode_start && this.barcode_end) {
          const start = Number(this.barcode_start);
          const end = Number(this.barcode_end);

          if (!isNaN(start) && !isNaN(end) && start >= end) {
            return "Barcode start must be less than barcode end";
          }

          if (!isNaN(start) && !isNaN(end) && end - start > 998) {
            return "Can't add more than 999 bulk samples";
          }
        }
      }

      return true;
    },
    async generateBagBarcode() {
      try {
        const response = await Vue.axios.get(
          "samples/samples/generateSampleBagBarcode"
        );
        const { data } = response;

        if (data && data.barcode) {
          if (this.sample_bag_barcode) {
            this.sample_bag_barcode = null;
          }
          this.isEditable = false;
          this.showBarcodeError = false;
          this.barcodeErrorMessage = "";
          this.sample_bag_barcode = data.barcode;
          return true;
        } else {
          console.warn("No success in response:", data);
          return false;
        }
      } catch (error) {
        console.error("Error Fetching Bag Barcode!", error);
        return false;
      }
    },
    openQrScanner(startBarCode) {
      if (this.scannerActive) return;
      if (
        this.active_sample.id != null ||
        (this.active_sample.number_of_samples > 0 && this.isBulk)
      )
        return;

      this.isStartBarCodeScanned = startBarCode;
      this.active_sample.sample_bag_barcode = "";
      this.isEditable = false;
      this.showQrScanner = true;
      this.scannerActive = true;
    },
    closeNumberOfSamplesDialog() {
      this.active_sample.number_of_samples = 0;
      this.isBulkBarCodeDialog = false;
    },
    saveNumberOfSamplesValue() {
      this.saveNumberOfSamples = true;
      this.active_sample.number_of_samples = this.numberOfSamplesValue;
      this.barcode_start = "";
      this.barcode_end = "";
      this.isBulkBarCodeDialog = false;
      this.numberOfSamplesValue = null;
    },
    closeScanner() {
      if (this.mediaStream) {
        this.mediaStream.getTracks().forEach(track => {
          track.stop();
        });
        this.mediaStream = null;
      }
      this.showQrScanner = false;
      this.scannerActive = false;
      if (this.$refs.scanner) {
        // Some barcode reader components have a stop() method
        if (typeof this.$refs.scanner.stop === "function") {
          this.$refs.scanner.stop();
        }
        // Or they might have a _stop() method
        if (typeof this.$refs.scanner._stop === "function") {
          this.$refs.scanner._stop();
        }
      }
    },
    onDialogToggle(val) {
      if (val) {
        this.$nextTick(() => {
          this.scannerActive = true;
        });
      } else {
        this.scannerActive = false;
      }
    },
    onQrDecode(decodedString) {
      if (!this.isStartBarCodeScanned && this.isBulk)
        this.barcode_end = decodedString;
      else this.barcodeField = decodedString;
      this.showBarcodeError = false;
      this.barcodeErrorMessage = "";
      this.emitBagBarcodeScan();
      this.closeScanner();
    },
    onQrInit(promise) {
      promise
        .then(stream => {
          this.mediaStream = stream;
        })
        .catch(err => {
          console.error("Camera init error:", err);
          this.closeScanner();
          alert("Camera initialization failed. Please allow camera access.");
        });
    },
    emitBagBarcodeScan() {
      this.$emit("bag-barcode-change", this.sample_bag_barcode);
    },
    handleClickGenerateBagBarCode() {
      if (this.isBulk) {
        this.$emit("number-of-samples-modal-opened");
        this.isEditable = false;
        this.sample_bag_barcode = "";
        this.barcode_start = "";
        this.barcode_end = "";
        this.isBulkBarCodeDialog = true;
      } else {
        this.active_sample.number_of_samples = 0;
        this.generateBagBarcode();
      }
    },
    switchMode() {
      this.$router.push(
        `/samples/${this.isBulk ? "sample-wizard" : "bulk-sample-wizard"}`
      );
    }
  },
  watch: {
    is_linked: function() {
      this.isLinkedPopulate();
    },
    showBarcodeError(newVal) {
      if (newVal) {
        this.barcodeErrorMessage = "This sample bag barcode is already in use";
      }
    },
    showQrScanner(newVal) {
      if (!newVal) this.closeScanner();
    },
    search(val) {
      return val && val !== this.value && this.loading !== true;
    },
    farm_id(farmId) {
      if (farmId) this.getFarmSources(farmId);
    },
    farms_source_id(farmsSourceId) {
      if (!farmsSourceId) return;
      this.getFarmSource({
        farm_id: this.farmId,
        source_id: farmsSourceId
      }).then(() => {
        this.quick_feed_type = null;
        this.populateFeedFields({
          feed_class_id: this.farmSource.feed_class_id,
          id: this.farmSource.feed_type_id
        });
        this.farmSource.copy_tos.forEach(copyTo => {
          this.setActiveSampleCopyTo(copyTo.id);
        });
      });
    },
    is_sample_bag: function() {
      this.sampleBagBarcodeFocus();
    },
    selectedClient(newVal) {
      if (newVal && newVal.id) {
        this.client_id = newVal.id;
        this.getActiveFarms(newVal.id);
        this.shownCopyTos = this.copyTos.filter(
          item =>
            item.is_active &&
            item.o_user_id &&
            item?._matchingData?.ClientsCopyTo?.client_id == newVal.id
        );
      }

      Promise.all([this.getClientLabs(this.selectedClient.id)]).then(data => {
        // Check for errors from any promise
        if (data.includes(false)) {
          this.error.message = "An error occurred while retrieving this sample";
        }
        if (this.labs.length == 1) {
          this.lab_id = this.labs[0].id;
        }
        this.loading = false;
      });
    },
    "$route.path": {
      handler(newPath) {
        if (newPath.includes("bulk-sample-wizard")) this.isBulk = true;
        else this.isBulk = false;
      },
      immediate: true
    },
    isBulkBarCodeDialog(newVal) {
      if (!newVal && !this.saveNumberOfSamples) {
        this.active_sample.number_of_samples = 0;
      }
    }
  },
  mounted() {
    this.isLinkedPopulate();
    this.lab_id =
      this.lab_id && this.labs.some(lab => lab.id == this.lab_id)
        ? this.lab_id
        : this.lab_id === true || this.lab_id === true
        ? null
        : localStorage.getItem("lab_id") &&
          this.labs.some(lab => lab.id == localStorage.getItem("lab_id"))
        ? JSON.parse(localStorage.getItem("lab_id"))
        : null;
    this.farm_id =
      this.farm_id && this.farms.some(farm => farm.id == this.farm_id)
        ? this.farm_id
        : localStorage.getItem("farm_id") &&
          this.farms.some(farm => farm.id == localStorage.getItem("farm_id"))
        ? JSON.parse(localStorage.getItem("farm_id"))
        : null;
    this.feed_type_id =
      this.feed_type_id &&
      this.feed_types.some(feed_type => feed_type.id == this.feed_type_id)
        ? this.feed_type_id
        : localStorage.getItem("feed_type_id") &&
          this.feed_types.some(
            feed_type => feed_type.id == localStorage.getItem("feed_type_id")
          )
        ? JSON.parse(localStorage.getItem("feed_type_id"))
        : null;
    this.active_sample.number_of_samples =
      this.sampleIds && this.sampleIds?.length >= 0
        ? this.sampleIds?.length
        : 0;
  }
};
</script>

<style>
.v-expansion-panel::before {
  transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: none;
}

.v-expansion-panel-header {
  padding: 0;
  width: 8rem;
}

.v-expansion-panel-content {
  display: flex;
  padding: 0;
}

.v-expansion-panel-content__wrap {
  padding: 0 !important;
  flex: 1 1 auto;
  max-width: 100%;
}

.mdi-chevron-down::before {
  content: "\F35D";
}

.barcode-btn {
  background-color: transparent !important;
  box-shadow: none;
  border: 1px solid #949494;
  text-transform: none;
}

.back-btn {
  border: 1px solid #000;
}

.v-card__actions > .v-btn.v-btn {
  padding: 0 8px;
  text-transform: none;
}
</style>
